/**
 * Debounce estándar. Uso previsto: validar disponibilidad de slug/subdominio
 * contra Supabase mientras el usuario escribe, sin disparar una consulta por
 * cada tecla (formulario de alta de empresa, módulo Empresas).
 *
 * @template {(...args: any[]) => void} F
 * @param {F} fn
 * @param {number} [esperaMs]
 * @returns {(...args: Parameters<F>) => void}
 */
export function debounce(fn, esperaMs = 300) {
  /** @type {ReturnType<typeof setTimeout> | undefined} */
  let temporizador;
  return (...args) => {
    clearTimeout(temporizador);
    temporizador = setTimeout(() => fn(...args), esperaMs);
  };
}
